import Constant from '@/const';
import axios from 'axios';

const getKfaData = async params => {
  try {
    const response = await axios.get(Constant.apiUrl.concat('/ihs/kfa'), {
      params,
    });
    return response;
  } catch (error) {
    const err = error;
    return err;
  }
};

export default getKfaData;
